import { Injectable } from '@angular/core';

import { BaseService, HttpService } from '../../../tms-shared';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseService extends BaseService {
  protected constructor(
    protected baseRoute: string,
    protected httpService: HttpService,
  ) {
    super(baseRoute, httpService);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
